// extracted by mini-css-extract-plugin
module.exports = {"profile":"profile__1XeKk","profile__avatar":"profile__avatar__2YDsr","profile__avatar__box":"profile__avatar__box__2GRzv","profile__menu":"profile__menu__12-P8"};